import { render, staticRenderFns } from "./BasketPane.vue?vue&type=template&id=11c8213a&"
import script from "./BasketPane.vue?vue&type=script&lang=js&"
export * from "./BasketPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports